import { BlastEvent, SimulationConfig } from '@/types';
import { getRadiusAtAngle } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const SpiralStarsAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  for(let i=0; i<15; i++){
    const p = (progress + i/15) % 1;
    const ang = p * Math.PI * 6 + i;
    const dst = e.maxRadius + p * 200;
    const r = getRadiusAtAngle(ang, e, dst);
    const sx = e.pos.x + Math.cos(ang)*r;
    const sy = e.pos.y + Math.sin(ang)*r;
    ctx.font = `${30*(1-p)}px Arial`; ctx.fillText("★", sx, sy);
  }
};

registerBlastAnimation('SPIRAL_STARS', SpiralStarsAnimation);
